interface WandIconProps extends React.ComponentPropsWithoutRef<'svg'> {
  color?: string;
}

export function WandIcon({ color = 'currentColor', ...svgProps }: WandIconProps) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <line
        x1="5.31152"
        y1="17.2326"
        x2="8.03894"
        y2="14.5052"
        stroke={color}
        strokeLinecap="round"
      />
      <line x1="3.5" y1="11.5" x2="7.5" y2="11.5" stroke={color} strokeLinecap="round" />
      <rect
        x="9.70711"
        y="12"
        width="3"
        height="21"
        rx="0.5"
        transform="rotate(-45 9.70711 12)"
        stroke={color}
      />
      <line x1="23.3536" y1="21.3536" x2="21.3536" y2="23.3536" stroke={color} />
      <line x1="15.3536" y1="13.3536" x2="13.3536" y2="15.3536" stroke={color} />
      <line
        x1="13.8984"
        y1="8.64641"
        x2="16.6258"
        y2="5.919"
        stroke={color}
        strokeLinecap="round"
      />
      <line
        x1="6.01863"
        y1="5.91895"
        x2="8.74604"
        y2="8.64636"
        stroke={color}
        strokeLinecap="round"
      />
      <line x1="11.5" y1="7.5" x2="11.5" y2="3.5" stroke={color} strokeLinecap="round" />
    </svg>
  );
}
